import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HeroCarouselViewer from '../components/HeroCarouselViewer';
import { heroProducts, shopProducts } from '../data/products';

function IconQuality() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 14.4l-4.8 2.5.9-5.4-3.9-3.8 5.4-.8L12 2z"
        stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}
function IconSpeed() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}
function IconMaterial() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3 3 8l9 5 9-5-9-5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M3 12l9 5 9-5M3 16l9 5 9-5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}
function IconSecure() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2 4 5v6c0 5 3.4 8.7 8 9 4.6-.3 8-4 8-9V5l-8-3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function HomePage() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <main className="home-page">
      <header className="hero-section">
        <div className="hero-grid centered-hero">
          <div className="hero-viewer-container">
            <HeroCarouselViewer
              products={heroProducts}
              activeIndex={activeIndex}
              onChangeIndex={setActiveIndex}
            />
          </div>
        </div>
      </header>

      <section className="customize-cta hud-frame">
        <span className="badge">Your Design, Our Printers</span>
        <h2>Got a model of your own?</h2>
        <p>Upload your own STL file and we'll bring it to life — pick a material, a color, and we'll handle the rest.</p>
        <Link to="/customize" className="customize-button">Customize Yours</Link>
      </section>

      <section className="features-section">
      <div className="features-grid">
        <article className="feature-card">
          <div className="feature-icon"><IconQuality /></div>
          <h3>Quality Prints</h3>
          <p>High-precision prints with strict QA — accurate tolerances and smooth finishes.</p>
        </article>
        <article className="feature-card">
          <div className="feature-icon"><IconSpeed /></div>
          <h3>Fast Turnaround</h3>
          <p>Printed and shipped quickly — we prioritize speed without sacrificing quality.</p>
        </article>
        <article className="feature-card">
          <div className="feature-icon"><IconMaterial /></div>
          <h3>Material Choice</h3>
          <p>PLA, PETG, ABS and resin options — pick the strength and finish you need.</p>
        </article>
        <article className="feature-card">
          <div className="feature-icon"><IconSecure /></div>
          <h3>Secure Checkout</h3>
          <p>Safe payments and friendly returns — shop with confidence.</p>
        </article>
      </div>
    </section>

      <section className="latest-prints">
        <div className="section-header">
          <h2>Latest Prints</h2>
          <Link to="/products">View all</Link>
        </div>
        <div className="product-grid">
          {shopProducts.slice(0,4).map(p => (
            <div className="product-card" key={p.id}>
              <div className="image-frame">
                <img src={p.image} alt={p.name} />
              </div>
              <h4>{p.name}</h4>
              <p>Rs{p.price}.00</p>
              <button className="view-button">View</button>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}